module.exports = __webpack_public_path__ + "img/carrousel-mamo-4.8c9c0489.jpg";